interface LogoProps {
  variant?: 'full' | 'mark' | 'wordmark'
  theme?: 'dark' | 'light'
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

export function Logo({ variant = 'full', theme = 'dark', className, size = 'md' }: LogoProps) {
  const sizes = {
    sm: { mark: 'h-8', wordmark: 'h-6', gap: 'gap-2' },
    md: { mark: 'h-12', wordmark: 'h-8', gap: 'gap-3' },
    lg: { mark: 'h-16', wordmark: 'h-10', gap: 'gap-4' },
  }

  const currentSize = sizes[size]

  if (variant === 'mark') {
    return <LogoMark className={className || currentSize.mark} />
  }

  if (variant === 'wordmark') {
    return <LogoWordmark theme={theme} className={className || currentSize.wordmark} />
  }

  return (
    <div className={`flex items-center ${currentSize.gap} ${className || ''}`}>
      <LogoMark className={`${currentSize.mark} w-auto`} />
      <LogoWordmark theme={theme} className={`${currentSize.wordmark} w-auto`} />
    </div>
  )
}

function LogoMark({ className }: { className?: string }) {
  return (
    <img
      src="/logo.png"
      alt="TruVine Technologies"
      className={className}
    />
  )
}

function LogoWordmark({ theme, className }: { theme?: 'dark' | 'light'; className?: string }) {
  const truVineColor = theme === 'light' ? '#1e3a8a' : '#ffffff'
  const techColor = theme === 'light' ? '#475569' : '#94a3b8'

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 290 32"
      fill="none"
      className={className}
    >
      <text
        x="0"
        y="24"
        fontFamily="Plus Jakarta Sans, system-ui, sans-serif"
        fontSize="26"
        fontWeight="700"
        letterSpacing="-0.02em"
        fill={truVineColor}
      >
        TruVine
      </text>

      <text
        x="105"
        y="24"
        fontFamily="Plus Jakarta Sans, system-ui, sans-serif"
        fontSize="26"
        fontWeight="500"
        letterSpacing="-0.02em"
        fill={techColor}
      >
        Technologies
      </text>
    </svg>
  )
}

export default Logo
